/**
 * Honour the OS-level "reduce motion" setting for autoplaying video.
 *
 * The global CSS block in base/_reduced-motion.scss collapses transition and
 * animation durations, but it cannot stop <video autoplay> — that has to be
 * done here.
 */
export function respectReducedMotion() {
  if (!window.matchMedia) {
    return;
  }

  const query = window.matchMedia("(prefers-reduced-motion: reduce)");

  const apply = () => {
    const videos = [...document.querySelectorAll("video")];

    for (let i = 0; i < videos.length; i++) {
      const video = videos[i];

      if (query.matches) {
        video.removeAttribute("autoplay");
        video.pause();
      }
    }
  };

  apply();

  // Safari < 14 only supports the deprecated addListener()
  if (query.addEventListener) {
    query.addEventListener("change", apply);
  } else if (query.addListener) {
    query.addListener(apply);
  }
}
